import React from "react";
import { useHistory } from "react-router-dom";
import { Card, CardBody, CardFooter, CardTitle, Col, Row } from "reactstrap";

// Card de KPI da aba "Cotação" da Torre (PO1-3628), no mesmo molde dos cards de
// IndicadoresDespacho / IndicadoresEntrega (card-stats). `link` abre a página
// de origem já no mesmo período; `variacao` é contra o período anterior.

export const fmtNumero = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR"));
export const fmtBRL = (v) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });
export const fmtPct = (v) =>
  v === null || v === undefined ? "—" : `${Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
export const fmtPctSigned = (v) => {
  if (v === null || v === undefined) return null;
  const n = Number(v);
  return `${n > 0 ? "+" : ""}${n.toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};
export const fmtRazao = (v) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function CardIndicador({ titulo, valor, subtitulo, icone, tom, link, variacao, variacaoInvertida, carregando, erro }) {
  const history = useHistory();
  const varTexto = fmtPctSigned(variacao);
  // Por padrão subir é ruim (acima do cotado, sem cotação, destinos sem tabela);
  // variacaoInvertida = subir é bom (economia).
  const pior = variacao === null || variacao === undefined ? null : variacaoInvertida ? variacao < 0 : variacao > 0;
  return (
    <Card
      style={{
        boxShadow: "0px 1px 20px 0px rgb(0, 0, 0)", // theme-ok: mesma sombra dos demais cards de indicador
        cursor: link ? "pointer" : "default",
      }}
      className="card-stats"
      onClick={link ? () => history.push(link) : undefined}
      title={link ? "Abrir o indicador neste período" : undefined}
    >
      <CardBody>
        <Row>
          <Col xs="4">
            <div className={`info-icon text-center ${tom || "icon-primary"}`}>
              <i className={icone} />
            </div>
          </Col>
          <Col xs="8">
            <div className="numbers">
              <CardTitle tag="h4">{titulo}</CardTitle>
              <CardTitle tag="h3">{carregando ? "…" : erro ? "—" : valor}</CardTitle>
            </div>
          </Col>
        </Row>
      </CardBody>
      <CardFooter>
        <hr />
        <div className="stats" style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
          <i className="tim-icons icon-sound-wave" />
          {erro ? <span>{erro}</span> : <span>{subtitulo}</span>}
          {!erro && varTexto ? (
            <span className={pior ? "text-danger" : "text-success"} style={{ fontWeight: 700 }}>
              {varTexto} vs período anterior
            </span>
          ) : null}
        </div>
      </CardFooter>
    </Card>
  );
}
